<div class="container-fluid">
  <app-header titleText="QUOTES" progressBarState="quote"></app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/quotes_circle.png" alt="Quote Icon" class="card-icon" />
      <div *ngIf="quoteSummary.quote.customer" class="container-fluid">
        <h5>{{quoteSummary.quote.customer.customer_BusinessName}}</h5>
        <div class="row header-text">
          <div class="col-3">
            <span *ngIf="quoteSummary.quote.customer.customer_Address1">{{quoteSummary.quote.customer.customer_Address1}}<br /></span>
            <span *ngIf="quoteSummary.quote.customer.customer_Address2">{{quoteSummary.quote.customer.customer_Address2}}<br /></span>
            <span *ngIf="quoteSummary.quote.customer.customer_City || quoteSummary.quote.customer.customer_State || quoteSummary.quote.customer.customer_Post">{{quoteSummary.quote.customer.customer_City}}, {{quoteSummary.quote.customer.customer_State}} {{quoteSummary.quote.customer.customer_Post}}<br /></span>
            <span i18n>Contact:</span> {{quoteSummary.quote.customer.contact_LastName}}, {{quoteSummary.quote.customer.contact_FirstName}}<br />
            <span *ngIf=quoteSummary.quote.customer.contact_Phone><span i18n>Phone:</span> {{quoteSummary.quote.customer.contact_Phone}}<br /></span>
            <span *ngIf=quoteSummary.quote.customer.contact_Mobile><span i18n>Cell:</span> {{quoteSummary.quote.customer.contact_Mobile}}<br /></span>
            <span *ngIf=quoteSummary.quote.customer.contact_Email>{{quoteSummary.quote.customer.contact_Email}}<br /></span>
          </div>
          <div class="col-3">
            <span *ngIf="quoteSummary.quote.jobType">{{quoteSummary.quote.jobType.jobType_Desc}}<br /></span>
            <span i18n>Office:</span> <span *ngIf="quoteSummary.quote.office">{{quoteSummary.quote.office.office_Name}}</span><br />
            <span i18n>Salesperson:</span> <span *ngFor="let assignment of quoteSummary.quote.quoteAssignments">{{assignment.assignedTo.firstName}} {{assignment.assignedTo.lastName}}</span><br />
            <span i18n>Blueprint Revision Date:</span> {{quoteSummary.quote.quote_PlanDate | date: 'MM/dd/yyyy'}}<br />
            <span i18n>Estimated Start Date:</span> {{quoteSummary.quote.quote_ReadyDate | date: 'MM/dd/yyyy'}}<br />
          </div>
          <div class="col-3">
            <span i18n>Project:</span> {{quoteSummary.quote.quote_Name}} #{{quoteSummary.quote.quote_ProjectNumber}}<br />
            <span i18n>Job Address</span><br />
            <span *ngIf="quoteSummary.quote.quote_Address1">{{quoteSummary.quote.quote_Address1}}<br /></span>
            <span *ngIf="quoteSummary.quote.quote_Address2">{{quoteSummary.quote.quote_Address2}} <br /></span>
            <span *ngIf="quoteSummary.quote.quote_City || quoteSummary.quote.quote_State || quoteSummary.quote.customer_Post">{{quoteSummary.quote.quote_City}}, {{quoteSummary.quote.quote_State}} {{quoteSummary.quote.quote_Post}}<br /></span>
            <span class="bold" i18n>Status:</span><br />
            <div *ngIf="quoteSummary.quote.quote_Converted; else unconvertedBlock">
              <p>
                <strong><span class="text-success">Sold</span></strong><br />
                <span i18n>Converted:</span> {{quoteSummary.quote.quote_Converted | date: 'MM/dd/yyyy'}}<br />
                <span i18n>Converted By:</span> <span *ngIf="quoteSummary.quote.quote_ConvertedBy"> {{quoteSummary.quote.quote_ConvertedByName}}</span>
              </p>
            </div>
            <ng-template #unconvertedBlock>
              <span *ngIf="quoteSummary.quote.quote_IsLost;">
                <strong><span style="color:red;" i18n>Lost</span></strong><br />
                <ng-template [ngIf]="quoteSummary.quote.lostReasonType"><span i18n>Lost Reason:</span> {{quoteSummary.quote.lostReasonType.lostReasonType_Desc}}<br /></ng-template>
                <ng-template [ngIf]="quoteSummary.quote.competitor"><span i18n>Lost To:</span> {{quoteSummary.quote.competitor.competitor_Desc}}<br /></ng-template>
                <ng-template [ngIf]="quoteSummary.quote.quote_LostNote"><span i18n>Notes:</span> {{quoteSummary.quote.quote_LostNote}}</ng-template>
              </span>
              <ng-template [ngIf]="!quoteSummary.quote.quote_IsLost">
                <span *ngIf="quoteSummary.quote.isExpired; else notExpiredBlock">
                  <strong><span style="color:red;" i18n>Expired</span></strong>
                </span>
                <ng-template #notExpiredBlock i18n>Active</ng-template>
              </ng-template>
            </ng-template>
          </div>
          <div class="col-sm-3" align="right">
            <h7><span i18n>Created By:</span> <ng-template [ngIf]="quoteSummary.quote.createdBy">{{quoteSummary.quote.createdBy.firstName}} {{quoteSummary.quote.createdBy.lastName}}</ng-template><br /></h7>
            <h7><span i18n>Date:</span> {{quoteSummary.quote.quote_Created | date: 'M/d/yyyy'}}</h7><br />
            <h7 *ngIf="quoteSummary.quote.quote_Modified"><span i18n>Modified Date:</span> {{quoteSummary.quote.quote_Modified | date: 'M/d/yyyy'}}</h7><br />
            <a href="http://maps.google.com/?q={{quoteSummary.quote.quote_Address1}},{{quoteSummary.quote.quote_City}}%20{{quoteSummary.quote.quote_State}}%20{{quoteSummary.quote.quote_Postal}}" target="_blank" class="btn btn-bidit-navigate" i18n>Map Quote</a>
            <button *ngIf="!isRequesting" type="button" (click)="materialList()" class="mb-1 ml-1 btn btn-bidit-navigate" i18n>Material List</button>
            <app-spinner [isRunning]="isRequesting"></app-spinner>
          </div>
        </div>

      </div>
      <br>
      <div class="container-fluid">
        <mat-tab-group>
          <mat-tab label="Quote Details" i18n-label>
            <div class="pt-3">
              <app-quote-details [quoteSummary]="quoteSummary" (updated)="quoteUpdated($event)"></app-quote-details>
            </div>
          </mat-tab>
          <mat-tab label="Customer Info" i18n-label>
            <div class="pt-3">
              <app-project-info projectType="quote" [quote]="quoteSummary.quote"
                                (updated)="quoteUpdated($event)"></app-project-info>
            </div>
          </mat-tab>
          <mat-tab *ngIf="quoteSummary.quote.notes" [label]="noteLabel">
            <div class="pt-3">
              <app-project-notes [project]="quoteSummary.quote"
                                 (updated)="quoteUpdated($event)"></app-project-notes>
            </div>
          </mat-tab>
          <mat-tab *ngIf="quoteSummary.quote.documents" [label]="documentLabel">
            <div class="pt-3">
              <app-project-documents [project]="quoteSummary.quote"
                                     (updated)="quoteUpdated($event)"></app-project-documents>
            </div>
          </mat-tab>
          <mat-tab *ngIf="quoteSummary.quote.quoteAcknowledgements" [label]="acknowledgementLabel">
            <div class="pt-3">
              <app-acknowledgement-list [project]="quoteSummary.quote"></app-acknowledgement-list>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

    </div>
  </div>
</div>

